import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconSettingsCog';
/** Renders an SVG icon. */
const SvgSettingsCog = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m8.333 6.768 2.542 1.316a9.4 9.4 0 0 1 3.152-1.306l.867-2.728a12 12 0 0 1 2.212 0l.867 2.728a9.4 9.4 0 0 1 3.152 1.306l2.542-1.316q.854.711 1.564 1.565l-1.316 2.542a9.4 9.4 0 0 1 1.307 3.152l2.728.867a12 12 0 0 1 0 2.212l-2.728.867a9.4 9.4 0 0 1-1.306 3.152l1.316 2.542a12 12 0 0 1-1.565 1.564l-2.542-1.316a9.4 9.4 0 0 1-3.152 1.307l-.867 2.728a12 12 0 0 1-2.212 0l-.867-2.728a9.4 9.4 0 0 1-3.152-1.306L8.333 25.23a12 12 0 0 1-1.565-1.564l1.316-2.542a9.4 9.4 0 0 1-1.306-3.152l-2.728-.867a12 12 0 0 1 0-2.212l2.728-.867a9.4 9.4 0 0 1 1.306-3.152L6.768 8.333q.711-.854 1.565-1.565m-2.526 4.058L4.383 8.075l.848-1.02a14 14 0 0 1 1.823-1.823l1.02-.848 2.752 1.424a11.4 11.4 0 0 1 1.625-.673l.94-2.955 1.321-.12a14 14 0 0 1 2.576 0l1.322.12.939 2.955a11 11 0 0 1 1.624.673l2.753-1.424 1.02.848c.662.55 1.273 1.16 1.823 1.823l.848 1.02-1.424 2.752q.397.781.673 1.625l2.955.94.12 1.321a14 14 0 0 1 0 2.576l-.12 1.322-2.955.939c-.183.562-.41 1.105-.673 1.624l1.424 2.753-.848 1.02a14 14 0 0 1-1.823 1.823l-1.02.848-2.753-1.424q-.78.397-1.624.673l-.94 2.955-1.321.12a14 14 0 0 1-2.576 0l-1.322-.12-.94-2.955a11.4 11.4 0 0 1-1.623-.673l-2.753 1.424-1.02-.848a14 14 0 0 1-1.823-1.823l-.848-1.02 1.424-2.753q-.397-.78-.673-1.624l-2.955-.94-.12-1.321a14 14 0 0 1 0-2.576l.12-1.322 2.955-.94q.276-.843.673-1.623Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-6 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
      />
    </svg>
  );
};
SvgSettingsCog.displayName = displayName;
export default SvgSettingsCog;
